namespace GeniuzPOS.QRreport {
    export enum promofg {
        allpro = 0,
        bspro = 1,
        advpro = 2
    }
    Serenity.Decorators.registerEnumType(promofg, 'GeniuzPOS.QRreport.promofg');
}
